import { render, staticRenderFns } from "./total-invest-dialog.vue?vue&type=template&id=d886f0c2"
import script from "./total-invest-dialog.vue?vue&type=script&lang=js"
export * from "./total-invest-dialog.vue?vue&type=script&lang=js"
import style0 from "./total-invest-dialog.vue?vue&type=style&index=0&id=d886f0c2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports